import { useEffect, useRef, type ReactNode } from 'react';
import { useIntersectionObserver } from '@/core/hooks/useIntersectionObserver';
import { PdpProductDetailsAccordionSections } from './PdpProductDetailsAccordionSections';

export interface PdpDesktopProductDetailsSection {
  id: string;
  title: string;
  content: ReactNode;
  defaultExpanded?: boolean;
  alwaysVisibleContent?: ReactNode;
}

interface PdpDesktopProductDetailsProps {
  topRows: ReactNode;
  sections: PdpDesktopProductDetailsSection[];
  onProductDetailsViewed?: () => void;
}

export function PdpDesktopProductDetails({
  topRows,
  sections,
  onProductDetailsViewed,
}: PdpDesktopProductDetailsProps) {
  const viewedRef = useRef(false);
  const { ref: sectionRef, meetsThreshold } = useIntersectionObserver<HTMLDivElement>({
    threshold: 0.2,
    disconnectOnIntersect: true,
  });

  useEffect(() => {
    if (meetsThreshold && !viewedRef.current) {
      viewedRef.current = true;
      onProductDetailsViewed?.();
    }
  }, [meetsThreshold, onProductDetailsViewed]);

  return (
    <div ref={sectionRef} className="w-full border border-[#e2e2e2] bg-white">
      <div className="border-b border-[#eee] bg-[#f9f9f9] px-4 py-2">
        <h3 className="text-xs font-bold uppercase tracking-wide text-black">Product Details</h3>
      </div>

      {topRows}

      <PdpProductDetailsAccordionSections sections={sections} />
    </div>
  );
}
